<top-banner variant="custom">
    <h2 class="title mb-3">Competency Types</h2>
    <button type="button" (click)="toggleCreateCompetencyTypeModal()" class="btn color_blue-btn btn-round">
      <i class="fas fa-plus"></i>
      &nbsp;
      <strong>CREATE NEW COMPETENCY TYPE</strong>
    </button>
</top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <!-- Table of results -->
          <div class="row">
            <div class="col-md-12">
              <p-table [value]="competencyTypes" selectionMode="single" [(selection)]="selectedCompetencyType" (onRowSelect)="onRowSelect($event)">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Id</th>
                    <th>Name</th>
                    <th>Type</th>
                    <th class="text-center">Required for all workers</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-type>
                  <tr [pSelectableRow]="type">
                    <td>{{ type.id }}</td>
                    <td>{{ type.value }}</td>
                    <td>
                      <span *ngIf="type.type === 'GENERAL_SITE'" class="badge badge-pill badge-success">General Site</span>
                      <span *ngIf="type.type === 'TURBINE'" class="badge badge-pill badge-info">Turbine</span>
                      <span *ngIf="type.type === 'POWERSTATION'" class="badge badge-pill badge-warning">Contractor</span>
                    </td>
                    <td class="text-center">
                      <i *ngIf="type.allWorkerRequired" class="fas fa-check-circle success"></i>
                      <i *ngIf="!type.allWorkerRequired" class="fas fa-times-circle danger"></i>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="3">No competency types found</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          <div class="card-footer">
            <p-paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="New Competency Type" [(visible)]="createCompetencyTypeModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="createCompetencyTypeForm" (ngSubmit)="onCreateCompetencyTypeFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" formControlName="value" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Type</label><br />
          <p-dropdown
            formControlName="type"
            [options]="typeOptions"
            optionLabel="display"
            [style]="{ width: '100%' }" >
        </p-dropdown>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group form-group-checkbox mt-0">
          <label>Required for all workers</label>
          <p-checkbox class="form-control" formControlName="allWorkerRequired" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-12" *ngIf="errorAlerts">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="createCompetencyTypeModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onCreateCompetencyTypeFormSubmit()" [disabled]="!createCompetencyTypeForm.valid" class="my-2 btn btn-round btn-sm btn-success">Create</button>
  </p-footer>
</p-dialog>

<p-dialog header="Edit Competency Type" [(visible)]="editCompetencyTypeModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="editCompetencyTypeForm" (ngSubmit)="onEditCompetencyTypeFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" formControlName="value" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Type</label><br />
          <p-dropdown formControlName="type" [options]="typeOptions" optionLabel="display" [style]="{ width: '100%' }"></p-dropdown>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group form-group-checkbox mt-0">
          <label>Required for all workers</label>
          <p-checkbox class="form-control" formControlName="allWorkerRequired" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-12">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="editCompetencyTypeModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onEditCompetencyTypeFormSubmit()" [disabled]="!editCompetencyTypeForm.valid" class="my-2 btn btn-round btn-sm btn-success">Save</button>
  </p-footer>
</p-dialog>
